import React, { useEffect, useState } from "react";
import "./Vacancies.css";

const Vacancies = () => {
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVacancies = async () => {
      try {
        const response = await fetch(
          "https://api.hh.ru/vacancies?employer_id=1103589&area=159&per_page=100",
          {
            headers: {
              "User-Agent": "VacanciesWidget/1.0",
              Accept: "application/json",
            },
          }
        );
        const data = await response.json();
        setVacancies(data.items || []);
      } catch (error) {
        console.error("Ошибка при загрузке вакансий:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVacancies();
  }, []);

  return (
    <section className="vacancies">
      <div className="vacancies__container">
        <div className="vacancies__header">
          <h2 className="vacancies__title">Актуальные вакансии</h2>
        </div>

        <div className="vacancies__content">
          <div className="vacancies__list">
            {loading ? (
              <div className="vacancies__loading">Загрузка вакансий...</div>
            ) : vacancies.length > 0 ? (
              vacancies.map((vacancy) => (
                <div key={vacancy.id} className="vacancy-card">
                  <h3 className="vacancy-card__title">
                    <a
                      href={vacancy.alternate_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="vacancy-card__link"
                    >
                      {vacancy.name}
                    </a>
                  </h3>
                  {/* {vacancy.salary && (
                    <div className="vacancy-card__salary">
                      {vacancy.salary.from && `от ${vacancy.salary.from}`}
                      {vacancy.salary.from && vacancy.salary.to && " до "}
                      {vacancy.salary.to && `${vacancy.salary.to}`}
                      {vacancy.salary.currency && ` ${vacancy.salary.currency}`}
                    </div>
                  )} */}
                  <div className="vacancy-card__meta">
                    {vacancy.area && (
                      <span className="vacancy-card__location">
                        {vacancy.area.name}
                      </span>
                    )}
                    {vacancy.schedule && (
                      <span className="vacancy-card__schedule">
                        {vacancy.schedule.name}
                      </span>
                    )}
                  </div>
                  {vacancy.snippet && vacancy.snippet.requirement && (
                    <div className="vacancy-card__requirements">
                      {vacancy.snippet.requirement}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="vacancies__empty">
                В данный момент нет открытых вакансий
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vacancies;
